(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["loop-blog"] && !Shopify.designMode) return;
  try {
    
(() => {
  const section = document.querySelector('[data-loop-slider]');
  if (!section) return;

  const track = section.querySelector('.loop-discovery__track');
  const slides = Array.from(section.querySelectorAll('.loop-discovery__slide'));
  const dots = Array.from(section.querySelectorAll('.loop-discovery__dot'));

  let index = 0;
  let startX = 0;
  let currentX = 0;
  let isDragging = false;
  let hasMoved = false;

  const slideWidth = () => section.querySelector('.loop-discovery__slider').offsetWidth;

  const setTranslate = (x, animate = true) => {
    track.style.transition = animate
      ? 'transform 0.6s cubic-bezier(0.22, 1, 0.36, 1)'
      : 'none';

    track.style.transform = `translateX(${x}px)`;
  };

  const update = () => {
    const x = -index * slideWidth();
    setTranslate(x);
    dots.forEach((dot, i) =>
      dot.classList.toggle('is-active', i === index)
    );
  };

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      index = i;
      update();
    });
  });

  const onStart = (x) => {
    startX = x;
    currentX = -index * slideWidth();
    isDragging = true;
    hasMoved = false;
    track.classList.add('is-dragging');
    setTranslate(currentX, false);
  };

  const onMove = (x) => {
    if (!isDragging) return;
    const delta = x - startX;
    if (Math.abs(delta) > 4) hasMoved = true;
    setTranslate(currentX + delta, false);
  };

  const onEnd = (x) => {
    if (!isDragging) return;
    isDragging = false;
    track.classList.remove('is-dragging');

    const delta = x - startX;
    const threshold = slideWidth() * 0.15;

    if (delta < -threshold && index < slides.length - 1) index++;
    if (delta > threshold && index > 0) index--;

    update();
  };

  // Mouse
  track.addEventListener('mousedown', e => onStart(e.clientX));
  window.addEventListener('mousemove', e => onMove(e.clientX));
  window.addEventListener('mouseup', e => onEnd(e.clientX));

  // Touch
  track.addEventListener('touchstart', e => onStart(e.touches[0].clientX), { passive: true });
  track.addEventListener('touchmove', e => {
    if (isDragging) e.preventDefault();
    onMove(e.touches[0].clientX);
  }, { passive: false });
  track.addEventListener('touchend', e => onEnd(e.changedTouches[0].clientX));

  // Prevent click when dragging
  track.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', e => {
      if (hasMoved) e.preventDefault();
    });
  });

  window.addEventListener('resize', update);
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produit-lp-loop"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.loop-eclipse-hero__play-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var wrapper = btn.closest('.loop-eclipse-hero__video-wrapper');
      var video = wrapper ? wrapper.querySelector('video') : null;
      if (!video) return;

      if (video.paused) {
        video.play();
        btn.style.display = 'none';
      } else {
        video.pause();
        btn.style.display = 'flex';
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
